import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-viewer',
  templateUrl: './full-viewer.component.html',
  styleUrls: ['./full-viewer.component.css']
})
export class FullViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
